import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import { Dispenser, ServiceType } from "@framework/shared";

export const dispenserRoutes: Array<RouteObject> = [
  {
    path: "/dispenser",
    element: <Protected />,
    children: [{ index: true, element: <Dispenser service={ServiceType.OFFICE} /> }],
  },
];
